<template>
  <div class="row documento_dados_designacao">
    <div class="small-12 medium-8 large-7 columns">
      <div class="row">
        <div class="small-4 medium-4 large-4 columns">
          <h3>
            {{$t("bolsas.UMA_LANG_DOCSBOLSA_CODIGO")}}
          </h3>
        </div>
        <div class="small-8 medium-8 large-8 columns">
          <h3>
            {{$t("bolsas.UMA_LANG_DOCSBOLSA_DESIGNACAO")}}
          </h3>
        </div>
      </div>
    </div>
    <div class="small-0 medium-4 large-5 columns hide-for-small-only">
      <div class="row">
        <div class="small-0 medium-0 large-6 columns show-for-large">
          <h3>
            {{$t("bolsas.UMA_LANG_DOCSBOLSA_DATALIMITE")}}
          </h3>
        </div>
        <div class="small-0 medium-6 large-6 columns">
          <h3>
            {{$t("bolsas.UMA_LANG_DOCSBOLSA_ESTADO")}}
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {


    return {}
  }
}
</script>

<style lang="scss" scoped>
.documento_dados_designacao, .row .row{
  margin-right: 0px;
  margin-left:  0px; 
}

.documento_dados_designacao .columns {
  padding-left: 0;
  padding-right: 0;
}

.documento_dados_designacao h3 {
  font-size: 12px;
  font-family: "Montserrat";
  text-transform: uppercase;
  color: #707475;
}

.documento_dados_designacao {
  border-bottom: 1px solid #a7a5a5;
}

@media (max-width: 1280px) {
.documento_dados_designacao h3 {
      font-size: 10px;
  }
}
</style>